module.exports = __webpack_public_path__ + "static/media/assistant-profile-finished.e16fe5cc.svg";